"use client";

import { motion } from "framer-motion";

export function TabletIllustration() {
  return (
    <svg
      viewBox="0 0 380 460"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full max-w-70 mx-auto"
      aria-hidden="true"
    >
      <motion.rect
        x="40"
        y="40"
        width="300"
        height="200"
        rx="12"
        stroke="var(--border-subtle)"
        strokeWidth="1.5"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 0.9, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
      />
      <motion.rect
        x="40"
        y="40"
        width="300"
        height="28"
        rx="12"
        fill="var(--border-subtle)"
        fillOpacity="0.25"
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: 1 }}
        style={{ originX: "40px" }}
        transition={{ duration: 0.5, delay: 0.5, ease: [0.16, 1, 0.3, 1] }}
      />
      {[0, 1, 2].map((i) => (
        <motion.circle
          key={i}
          cx={58 + i * 16}
          cy={54}
          r="4"
          fill={i === 0 ? "var(--brand-primary)" : "var(--border-subtle)"}
          fillOpacity={i === 0 ? 0.7 : 0.5}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            duration: 0.3,
            delay: 0.65 + i * 0.07,
            ease: "backOut",
          }}
        />
      ))}
      {[
        { x: 64, y: 90, w: 160, h: 8 },
        { x: 64, y: 108, w: 110, h: 8 },
        { x: 64, y: 126, w: 140, h: 8 },
        { x: 64, y: 144, w: 90, h: 8 },
        { x: 64, y: 162, w: 130, h: 8 },
        { x: 64, y: 180, w: 100, h: 8 },
      ].map(({ x, y, w, h }, i) => (
        <motion.rect
          key={i}
          x={x}
          y={y}
          width={w}
          height={h}
          rx="4"
          fill={i % 3 === 0 ? "var(--brand-primary)" : "var(--border-subtle)"}
          fillOpacity={i % 3 === 0 ? 0.3 : 0.18}
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          style={{ originX: `${x}px` }}
          transition={{
            duration: 0.4,
            delay: 0.75 + i * 0.06,
            ease: [0.16, 1, 0.3, 1],
          }}
        />
      ))}

      <motion.rect
        x="40"
        y="268"
        width="136"
        height="152"
        rx="10"
        stroke="var(--border-subtle)"
        strokeWidth="1.5"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 0.7, delay: 1.0, ease: [0.16, 1, 0.3, 1] }}
      />
      {[0, 1, 2, 3].map((i) => (
        <motion.rect
          key={i}
          x={56}
          y={288 + i * 22}
          width={i % 2 === 0 ? 88 : 64}
          height={8}
          rx="4"
          fill="var(--border-subtle)"
          fillOpacity="0.22"
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          style={{ originX: "56px" }}
          transition={{
            duration: 0.35,
            delay: 1.1 + i * 0.06,
            ease: [0.16, 1, 0.3, 1],
          }}
        />
      ))}
      <motion.rect
        x="56"
        y="376"
        width="88"
        height="24"
        rx="6"
        fill="var(--brand-primary)"
        fillOpacity="0.25"
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: 1 }}
        style={{ originX: "56px" }}
        transition={{ duration: 0.35, delay: 1.35, ease: [0.16, 1, 0.3, 1] }}
      />

      <motion.rect
        x="204"
        y="268"
        width="136"
        height="152"
        rx="10"
        stroke="var(--border-subtle)"
        strokeWidth="1.5"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 1 }}
        transition={{ duration: 0.7, delay: 1.1, ease: [0.16, 1, 0.3, 1] }}
      />
      {[0, 1, 2, 3].map((i) => (
        <motion.rect
          key={i}
          x={220}
          y={288 + i * 22}
          width={i % 2 === 0 ? 72 : 96}
          height={8}
          rx="4"
          fill="var(--border-subtle)"
          fillOpacity="0.22"
          initial={{ scaleX: 0, opacity: 0 }}
          animate={{ scaleX: 1, opacity: 1 }}
          style={{ originX: "220px" }}
          transition={{
            duration: 0.35,
            delay: 1.2 + i * 0.06,
            ease: [0.16, 1, 0.3, 1],
          }}
        />
      ))}
      <motion.rect
        x="220"
        y="376"
        width="88"
        height="24"
        rx="6"
        fill="var(--border-subtle)"
        fillOpacity="0.18"
        initial={{ scaleX: 0, opacity: 0 }}
        animate={{ scaleX: 1, opacity: 1 }}
        style={{ originX: "220px" }}
        transition={{ duration: 0.35, delay: 1.45, ease: [0.16, 1, 0.3, 1] }}
      />

      <motion.path
        d="M190 155 L190 268"
        stroke="var(--border-subtle)"
        strokeWidth="1"
        strokeDasharray="4 6"
        initial={{ pathLength: 0, opacity: 0 }}
        animate={{ pathLength: 1, opacity: 0.4 }}
        transition={{ duration: 0.5, delay: 1.0, ease: "easeOut" }}
      />
      <motion.circle
        cx="190"
        cy="268"
        r="3"
        fill="var(--brand-primary)"
        fillOpacity="0.5"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3, delay: 1.5, ease: "backOut" }}
      />
    </svg>
  );
}
